import RouterView from '@/page/main/DefaultRouterView'
import Create from '@/page/meeting/create'
import Edit from '@/page/meeting/edit'
import List from '@/page/meeting/list'
import RoomList from '@/page/meeting/roomlist'

import CreateApproval from '@/page/meeting/createApproval'
import ApprovalList from '@/page/meeting/approvalList'


export default {
  path: '/Meeting',
  component: RouterView,
  children: [{
      path: 'CreateApproval',
      meta: {
        type: ['meeting', 'meetingapprovallist'],
        title: '创建会议'
      },
      component: CreateApproval
    },
    {
      path: 'ApprovalList',
      meta: {
        type: ['meeting', 'meetingapprovallist'],
        title: '会议申请审批列表'
      },
      component: ApprovalList
    },
    // {
    //     path: 'Create',
    //     meta: {
    //       type: ['meeting', 'meetinglist'],
    //       title: '创建会议'
    //     },
    //     component: Create
    //   },
    {
      path: 'Edit/:id',
      meta: {
        type: ['meeting', 'meetinglist'],
        title: '编辑会议'
      },
      component: Edit
    },
    {
      path: 'List',
      meta: {
        type: ['meeting', 'meetinglist'],
        title: '会议列表'
      },
      component: List
    },
    {
      path: 'Room/List',
      meta: {
        type: ['meeting', 'meetingroomlist'],
        title: '会议室列表'
      },
      component: RoomList
    }
  ]
}


// WEBPACK FOOTER //
// ./src/router/meeting.js